<!-- <Loader :loading="loading" /> -->

<CreateDocumentApproval
  @temporary-document="handle_temporary_document"
  @document-created="handle_document_created"
/>
<teleport to="body">
<!-- Modal for editing document approval -->
<div class="modal fade" id="edit_document_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content create-approval-modal">
        <div class="modal-header position-relative justify-content-between">
        <div>
          <p class="modal-title fw-bold" id="exampleModalLabel">Edit document approval</p>
          <p class="text-xs text-muted mb-0">Update the document details, reviewers, or attached media.</p>
        </div>
        <button
          type="button"
          class="btn-close create-approval-close position-absolute end-0 top-50 translate-middle-y me-3"
          data-bs-dismiss="modal"
          aria-label="Close">
        </button>
      </div>
      <form @submit.prevent="edit_document_data" class="create-approval-form">
        <div class="modal-body modal-body-scroll create-approval-body">
          <div class="create-approval-section">
            <label for="document_name" class="form-label create-approval-label">Document Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control create-approval-input text-xxs" id="document_name" placeholder="Enter document name"
              v-model="document_name">
            <p v-if="errors.edit_document_name" class="text-danger text-xxs">{{ errors.edit_document_name }}</p>
          </div>

          <!-- Select Reviewer -->
          <div class="create-approval-section">
            <div class="flex-grow-1">
              <label for="reviewer" class="form-label create-approval-label">
                Assign reviewers:
                <span class="text-danger">*</span>
              </label>

              <multiselect
                v-model="tempSelectedReviewer"
                :options="reviewers"
                :searchable="true"
                :internal-search="true"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="false"
                placeholder="Search reviewers"
                label="full_name"
                track-by="portal_access_id"
                class="create-approval-reviewers text-xxs fw-500"
              >
                <template #option="{ option }">
                  <span v-if="option.user">
                    {{ option.user.first_name }} {{ option.user.last_name }}
                  </span>
                  <span v-else class="text-muted">Member</span>
                </template>
                <template #selection="{ values }">
                    <span
                    v-for="(reviewer, index) in values"
                    :key="index"
                    class="create-approval-reviewer-badge"
                  >
                    <span v-if="reviewer.user">
                      {{ reviewer.user.first_name }} {{ reviewer.user.last_name }}
                    </span>
                    <span v-else>
                    {{reviewer.name}}
                    </span>
                  </span>
                </template>
              </multiselect>
              <p v-if="errors.reviewer" class="text-danger text-xxs">{{ errors.reviewer }}</p>
            </div>
          </div>

           <div class="create-approval-section">
             <div class="textarea-container">
               <label class="form-label create-approval-label">Description</label>
               <QuillEditor theme="snow" v-model="document_description" ref="quillDocumentEditorRef" class="quill-editor"
               placeholder="Enter your description here..." toolbar="full" />
            </div>
           </div>

          <div class="create-approval-section">
            <div class="file-upload flex-grow-1 d-flex flex-column align-items-center">

              <div v-if="edit_previews.length" class="d-flex flex-wrap gap-3 mb-3 px-1 w-100">
                <div v-for="(preview, index) in edit_previews" :key="index" class="preview-item position-relative mb-2">
                  <img v-if="preview.type === 'image'" :src="preview.src" class="preview-image rounded-3 border" />

                  <div v-else-if="preview.type === 'video'" class="position-relative w-100 h-100">
                    <video class="preview-video rounded border">
                      <source :src="preview.src" />
                    </video>
                    <i class="bi bi-play-circle-fill position-absolute top-50 start-50 translate-middle text-white fs-3 opacity-75"></i>
                  </div>

                  <div v-else class="preview-item rounded-3 border bg-light d-flex flex-column align-items-center justify-content-center text-center p-1">
                    <i v-if="preview.name.endsWith('.pdf')" class="bi bi-file-earmark-pdf-fill text-danger fs-2"></i>
                    <i v-else-if="preview.name.endsWith('.doc') || preview.name.endsWith('.docx')" class="bi bi-file-earmark-word-fill text-primary fs-2"></i>
                    <i v-else-if="preview.name.endsWith('.xls') || preview.name.endsWith('.xlsx')" class="bi bi-file-earmark-excel-fill text-success fs-2"></i>
                    <i v-else class="bi bi-file-earmark-text-fill text-secondary fs-2"></i>

                    <span class="text-xxs text-truncate w-100 px-1">{{ preview.name }}</span>
                  </div>

                  <button type="button" class="btn btn-sm btn-danger fw-bold position-absolute top-0 end-0 fs-6 px-2 py-0" @click="removeEditApprovalFile(index)">
                    &times;
                  </button>
                </div>
              </div>

              <div
                class="drop-zone-stable d-flex align-items-center justify-content-center pointer border-2 rounded p-3 text-center transition-all position-relative w-100"
                :class="edit_isDragging ? 'border-primary bg-primary-subtle' : 'border-dashed'"
                @dragover.prevent="edit_isDragging = true"
                @dragenter.prevent="edit_isDragging = true"
                @dragleave.prevent="edit_isDragging = false"
                @drop.prevent="handleEditApprovalDrop"
                @click="$refs.editApprovalFileInput.click()"
              >
                <div class="d-flex align-items-center justify-content-center gap-2 h-100">
                  <i class="bi bi-cloud-plus-fill text-primary fs-4"></i>
                  <span class="fw-bold text-black text-sm">Drag & Drop media here or click</span>
                </div>

                <input type="file" ref="editApprovalFileInput" id="editdocumentFileInput" class="file-input d-none" multiple @change="handleEditFileUpload"/>
              </div>

              <div v-if="fileError" class="text-xxs text-danger fst-italic mt-1">{{ fileError }}</div>
            </div>
          </div>
          <div class="create-approval-section" v-if="edit_documents.document_approval_files && edit_documents.document_approval_files.length">
            <label class="form-label create-approval-label">Current File</label>
            <div class="d-flex flex-wrap gap-3 px-1">
              <div v-for="(fileObj, index) in edit_documents.document_approval_files" :key="index" class="preview-item position-relative mb-2">

                  <!-- Image -->
                  <img v-if="fileObj.file.file_url.includes('.jpg') || fileObj.file.file_url.includes('.png') || fileObj.file.file_url.includes('.jpeg')"
                       :src="fileObj.file.file_url"
                       alt="Feed Image"
                       class="preview-image rounded-3 border"
                       :class="{ 'zoomed-in': isZoomed }"
                       ref="image" />

                  <!-- Audio -->
                  <audio v-else-if="fileObj.file.file_url.includes('.mp3') || fileObj.file.file_url.includes('.wav')"
                         controls
                         class="w-100 rounded p-1">
                    <source :src="fileObj.file.file_url" type="audio/mp3" />
                    Your browser does not support the audio element.
                  </audio>

                  <!-- Video -->
                  <video v-else-if="/\.(mp4|webm|ogg|ogv|mov|m4v|avi|mkv|wmv|flv|3gp|3g2)(?:$|[?#])/i.test(fileObj.file.file_url)" controls
                         class="preview-video rounded border">
                    <source :src="fileObj.file.file_url" />
                    Your browser does not support the video tag.
                  </video>

                  <div v-else class="preview-item rounded-3 border bg-light d-flex flex-column align-items-center justify-content-center text-center p-1">
                    <i v-if="fileObj.file.file_url.includes('.pdf')" class="bi bi-file-earmark-pdf-fill text-danger fs-2"></i>
                    <i v-else-if="fileObj.file.file_url.includes('.docx') || fileObj.file.file_url.includes('.doc')" class="bi bi-file-earmark-word-fill text-primary fs-2"></i>
                    <i v-else-if="fileObj.file.file_url.includes('.xls') || fileObj.file.file_url.includes('.xlsx') || fileObj.file.file_url.includes('.xlsm') || fileObj.file.file_url.includes('.xlsb')" class="bi bi-file-earmark-excel-fill text-success fs-2"></i>
                    <i v-else class="bi bi-file-earmark-text-fill text-secondary fs-2"></i>
                    <span class="text-xxs text-truncate w-100 px-1">{{ getFileName(fileObj.file.file_url) }}</span>
                  </div>

                </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary text-xs rounded px-4">Update</button>
        </div>
      </form>
          </div>
    </div>
</div>
</teleport>
<div class="temporary-post posting-loader-card" v-if="temporary_post" id="temp-post">
  <div class="posting-loader-icon" aria-hidden="true">
    <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
  </div>
  <div class="posting-loader-content">
    <div class="d-flex align-items-center justify-content-between gap-2">
      <p class="mb-0 fw-bold text-xs">Submitting document approval</p>
      <span class="posting-loader-status">Saving</span>
    </div>
    <p class="mb-2 text-muted text-xxs text-truncate">{{ temporary_post.document_name || 'Document approval' }}</p>
    <div class="posting-loader-track" aria-hidden="true">
      <span></span>
    </div>
  </div>
</div>

<div v-if="loading" class="text-center py-5 w-100">
      <!-- Loader spinner (Bootstrap example) -->
      <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2 mb-0 text-muted">Loading document approvals...</p>
  </div>

<div v-else>
<div v-if="document_approvals.length">
 <div class="document-approval-container approval-board">

    <!-- DESKTOP/TABLET: tabs + content -->
    <div class="tabs-container approval-tabs-wrap justify-content-between">
      <div class="nav nav-pills custom-tabs approval-tabs w-100 justify-content-between" role="tablist">
        <button
          class="nav-link tab-button pending-tab"
          :class="{ active: active_tab === 'pending' }"
          @click="setActiveTab('pending')"
          type="button"
        >
          <span>Pending</span>
          <strong>{{ pendingDocuments.length }}</strong>
        </button>

        <button
          class="nav-link tab-button approved-tab"
          :class="{ active: active_tab === 'approved' }"
          @click="setActiveTab('approved')"
          type="button"
        >
          <span>Approved</span>
          <strong>{{ approvedDocuments.length }}</strong>
        </button>

        <button
          class="nav-link tab-button rejected-tab"
          :class="{ active: active_tab === 'rejected' }"
          @click="setActiveTab('rejected')"
          type="button"
        >
          <span>Rejected</span>
          <strong>{{ rejectedDocuments.length }}</strong>
        </button>
        <button
          class="nav-link tab-button no-approval-tab d-none"
          :class="{ active: active_tab === 'no_approval' }"
          @click="setActiveTab('no_approval')"
          type="button"
        >
          <span>No Approval</span>
          <strong>{{ noApprovalDocuments.length }}</strong>
        </button>
        <button
          class="nav-link tab-button request-changes-tab"
          :class="{ active: active_tab === 'request_changes' }"
          @click="setActiveTab('request_changes')"
          type="button"
        >
          <span>Change Requests</span>
          <strong>{{changesRequestedDocuments.length}}</strong>
        </button>
      </div>
    </div>

    <!-- DESKTOP: your existing list, now desktop-only -->
    <div class="tab-content overflow-auto documents-scroll approval-documents-scroll">
      <div v-if="filteredDocuments.length" class="tab-pane active">
        <div v-for="document in filteredDocuments" :key="document.id" class="card mb-3 approval-document-card">

          <!-- Document Header -->
          <div class="card-header approval-document-header d-flex justify-content-between align-items-start gap-2">
            <h6 class="approval-document-title mb-0">
              <i class="bi bi-file-earmark-text me-2"></i> {{ truncate_document_name(document.name) }}
            </h6>
            <div class="dropstart" @click.stop v-if="String(document.creater?.id) === String(user_id)">
              <a href="#" class="approval-menu-btn" id="dropdownMenuButton" data-bs-toggle="dropdown">
                <i class="bi bi-three-dots-vertical"></i>
              </a>
              <ul class="dropdown-menu custom-dropdown">
                <li v-if="['pending', 'rejected', 'request_changes', 'no_approval'].includes(document.status.name)">
                  <a class="dropdown-item text-xxs fw-bold" href="#"
                    @click.prevent="open_edit_document_modal(document)">
                    <i class="bx bxs-edit"></i> Edit
                  </a>
                </li>
                <li>
                  <a class="dropdown-item text-xxs fw-bold" href="#" @click.prevent="deleteDocument(document.id)">
                    <i class='bx bxs-trash-alt'></i> Delete
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <!-- File List -->
          <div class="card-body approval-document-body">
            <div class="approval-description mb-3" v-html="document.description"></div>

            <div v-for="(fileObj, index) in document.document_approval_files" :key="index">
                <div class="uploaded-file approval-uploaded-file d-flex align-items-center justify-content-between p-3 mb-2 rounded shadow-sm" @click="previewDocument(fileObj)">
                  <div class="approval-file-summary d-flex align-items-center justify-center min-w-0">
                    <img :src="getFileIcon(fileObj.file.file_url)" class="file-icon small-icon me-2" />
                    <div class="file-details min-w-0">
                      <span class="file-name d-block">
                        {{ getFileName(fileObj.file.file_url) }}
                      </span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center gap-3 flex-shrink-0 ms-3">
                    <a
                      :href="fileObj.file.file_url"
                      download
                      :title="getFileName(fileObj.file.file_url)"
                      class="file-action-btn"
                    >
                      <i class="bi bi-download"></i>
                    </a>
                </div>
                </div>
              
            </div>

            <div class="approval-meta text-xxs mt-3">
              <span>
                <i class="bi bi-person me-1"></i>Requested by <strong>{{ document.creater?.first_name ||'unknown' }} {{ document.creater?.last_name  ||'user' }}</strong>
              </span>
              <span>
                <i class="bi bi-calendar3 me-1"></i>Created on <strong>{{ formatDate(document.date_created) }}</strong>
              </span>
            </div>

            <!-- Reviewers Section with Individual Progress -->
          <div class="approval-timeline mt-4">
            <div
              v-for="(approver, index) in document.reviewer"
              :key="approver.id"
              class="reviewer-item d-flex align-items-stretch w-100"
              >
              <div class="reviewer-timeline d-flex flex-column align-items-center">
                <!-- Approver Circle -->
                <div
                  class="rounded-circle d-flex justify-content-center align-items-center reviewer-circle position-relative"
                  :class="{
                    'bg-success': approver.status === 'approved',
                    'bg-danger': approver.status === 'rejected',
                    'bg-primary': approver.status === 'request_changes',
                    'bg-warning': approver.status === 'pending'
                  }"
                  >
                  <i class="bi bi-person-fill text-white reviewer-fallback-icon"></i>

                  <!-- Status Badge -->
                  <div
                    class="status-badge position-absolute rounded-circle border-2 border-white d-flex align-items-center justify-content-center"
                    :class="{
                      'bg-success': approver.status === 'approved',
                      'bg-danger': approver.status === 'rejected',
                      'bg-primary': approver.status === 'request_changes',
                      'bg-warning': approver.status === 'pending'
                    }"
                    >
                    <i
                    class="text-white"
                    :class="{
                      'bi bi-check': approver.status === 'approved',
                      'bi bi-x': approver.status === 'rejected',
                      'bi bi-arrow-repeat': approver.status === 'request_changes',
                      'bi bi-clock': approver.status === 'pending'
                    }"
                    ></i>
                  </div>
                </div>

                <!-- Vertical Connector Line -->
                <div
                  v-if="index < document.reviewer.length - 1"
                  class="reviewer-line-wrapper d-flex align-items-center justify-content-center"
                  >
                  <div
                  class="reviewer-line h-100"
                  :class="{
                    'bg-success': approver.status === 'approved',
                    'bg-danger': approver.status === 'rejected',
                    'bg-primary': approver.status === 'request_changes',
                    'bg-warning': approver.status === 'pending'
                  }"
                  ></div>
                </div>
              </div>

            <div class="reviewer-details d-flex align-items-center justify-content-between min-w-0">
              <div class="min-w-0">
                <p class="mb-1 fw-semibold text-xs text-truncate reviewer-name">
                  {{ approver.first_name }} {{ approver.last_name }}
                </p>
              <span
                class="task-chip task-chip-status task-chip-tone-1 text-xxs"
              >
                {{ formatStatus(approver.status) }}
              </span>
            </div>

            </div>
            </div>
          </div>

            <!-- Reviewer Comments Section -->
            <div v-if="has_reviewer_comments(document) && (document.status?.name === 'request_changes' || document.status === 'request_changes'
                    || document.status?.name === 'rejected' || document.status === 'rejected')"
                 class="approval-comments mt-3">

              <div class="approval-comments-header">
                <h6 class="fw-bold mb-0 text-xxs">Reviewer Comments</h6>
              </div>
              <div v-for="(reviewer, rIndex) in reviewer_comments(document)" :key="rIndex" class="approval-comment-item">
                <div class="d-flex align-items-start gap-2">
                  <div class="approval-comment-avatar">
                    <img
                      v-if="reviewer.profile_picture"
                      :src="reviewer.profile_picture"
                      alt="Reviewer"
                      class="rounded-circle me-2 profile-list-avatar"
                    />
                    <img
                      v-else
                      src="@/assets/images/user.svg"
                      alt="Default Reviewer"
                      class="rounded-circle"
                    />
                  </div>
                  <div class="approval-comment-body">
                    <div class="approval-comment-meta">
                      <span class="approval-comment-name">{{ reviewer.first_name }} {{ reviewer.last_name }}</span>
                      <span
                        class="approval-comment-status"
                        :class="{
                          'is-change': reviewer.status === 'request_changes',
                          'is-rejected': reviewer.status === 'rejected',
                          'is-approved': reviewer.status === 'approved',
                          'is-pending': reviewer.status === 'pending'
                        }"
                      >
                        {{ formatStatus(reviewer.status) }}
                      </span>
                    </div>
                    <p class="approval-comment-text">{{ reviewer.comment }}</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Action Buttons -->
            <div v-if="is_reviewer(document) && document.status.name === 'pending'" class="approval-actions d-flex text-center mt-3">
              <template v-if="is_next_reviewer(document)">
                <button class="approval-action-btn is-approve flex-fill btn" @click="approve_document(document.id)">
                  <i class="bi bi-check-circle me-1"></i> Approve
                </button>
                <button class="approval-action-btn is-change flex-fill btn" @click="requestChanges(document.id)">
                  <i class="bi bi-arrow-repeat me-1"></i> Request Changes
                </button>
                <button class="approval-action-btn is-reject flex-fill btn" @click="reject_document(document.id)">
                  <i class="bi bi-x-circle me-1"></i> Reject
                </button>
              </template>

              <div v-else class="approval-waiting-state w-100">
                <span class="approval-waiting-icon" aria-hidden="true">
                  <i class="bi bi-hourglass-split"></i>
                </span>
                <div class="text-start">
                  <p class="mb-0 text-muted text-xxs">Reviewers need to complete their review first.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div v-else class="empty-state text-center py-5">
        <div class="empty-icon mb-3">
          <i class="bi bi-inbox" ></i>
        </div>
        <h6 class="text-muted">No {{ active_tab.replace('_', ' ') }} documents found</h6>
        <p class="text-muted small">Documents will appear here when they match this status.</p>
      </div>
    </div>
  </div>
</div>


<div v-else class="text-center">No available document approvals</div>

</div>
<teleport to="body">
<!-- Document Preview Modal -->
<div class="modal fade" id="document_preview_modal" tabindex="-1" aria-labelledby="documentPreviewModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="documentPreviewModalLabel">Document Preview</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body position-relative">
        <!-- Loader -->
        <div v-if="loading_preview" class="d-flex justify-content-center align-items-center" style="height: 600px;">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <!-- Dynamically display document content -->
        <div v-if="previewDocumentType === 'pdf'">
          <iframe
            :src="previewDocumentUrl"
            width="100%"
            height="600px"
            @load="loading_preview = false"
          ></iframe>
        </div>
        <div v-else-if="previewDocumentType === 'word'">
          <iframe
            :src="previewDocumentUrl"
            width="100%"
            height="600px"
            @load="loading_preview = false"
          ></iframe>
        </div>
        <div v-else-if="previewDocumentType === 'excel'">
          <iframe
            :src="previewDocumentUrl"
            width="100%"
            height="600px"
            @load="loading_preview = false"
          ></iframe>
        </div>
        <div v-else-if="previewDocumentType === 'powerpoint'">
          <iframe
            :src="previewDocumentUrl"
            width="100%"
            height="600px"
            @load="loading_preview = false"
          ></iframe>
        </div>
        <div v-else-if="previewDocumentType === 'image'">
          <img
            :src="previewDocumentUrl"
            class="img-fluid"
            alt="Document Image"
            @load="loading_preview = false"
          >
        </div>
      </div>
    </div>
  </div>
</div>
</teleport>







